<template>
    <widget-wrapper :loader="api" :title="$t('widgets.geotable.title')" id="geotable">
        <div class="table__responsive">
            <table class="table--hover--clickable">
                <geo-table-bread-crumb :breadcrumbs="breadcrumbs" :columns="columns"
                                       @crumb-click="onBreadcrumbClicked"/>
                <geo-table-head :mode="activeCode" :columns="columns"/>
                <geo-table-body :items="activeView.child" :columns="columns" @child-click="onChildClicked"/>
            </table>
        </div>
    </widget-wrapper>
</template>

<script>
    import {Component} from 'vue-property-decorator';
    import DashboardWidget from '../DashboardWidget';
    import WidgetWrapper from '../WidgetWrapper';
    import WidgetData from '../WidgetDataDecorator';
    import _ from 'lodash';
    import GeoTableBreadCrumb from './GeoTableBreadCrumb';
    import GeoTableHead from './GeoTableHead';
    import GeoTableBody from './GeoTableBody';

    function populate() {
        return {
            lead: _.random(1, 100),
            appointment: _.random(1, 100),
            offer: _.random(1, 100),
            sales: _.random(1, 100),
        };
    }

    @Component({
        components: {
            GeoTableBody,
            GeoTableHead,
            GeoTableBreadCrumb,
            WidgetWrapper,
        }
    })
    export default class GeoTableWidget extends DashboardWidget {
        api = {
            endpoint: 'dashboard/api/sales/geo_data',
            allow404: true,
        };
        @WidgetData(() => ([]))
        countries;

        columns = ['lead', 'appointment', 'offer', 'sales'];

        get world() {
            return {
                name: 'all',
                data: this.totals,
                child: this.countries,
            };
        }

        get totals() {
            if (!this.countries.length) {
                return _.times(4, () => 0);
            }
            const columns = this.countries[0].data.map(i => i.name);
            const groups = _.times(columns.length, () => ([]));
            this.countries.reduce((sum, country) => {
                country.data.forEach((entry, index) => sum[index].push(entry));
                return sum;
            }, groups);
            return groups.map(group => ({value: group.reduce((sum, entry) => sum + entry.value, 0)}));
        }

        breadcrumbs = [];
        activeView = null;
        activeCode = 'country_id';

        show(view) {
            this.activeView = view;
            if (view.child.length) {
                this.activeCode = view.child[0].code;
            } else {
                this.activeCode = 'country_id';
            }
            this.breadcrumbs.push(view);
        }

        created() {
            this.show(this.world);
        }

        onQueryData(response) {
            console.log('queryData');
            if (response && response.data) {
                this.countries = response.data;
            } else {
                this.countries = [];
            }
            this.breadcrumbs = [];
            this.show(this.world);
        }

        onBreadcrumbClicked(crumb) {
            // Pop crumbs until we have popped the clicked crumb off.
            while (this.breadcrumbs.length) {
                if (this.breadcrumbs.pop() === crumb) {
                    break;
                }
            }
            // Show the children of the clicked crumb
            this.show(crumb);
        }

        onChildClicked(child) {
            if (child.child && child.child.length) {
                this.show(child);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/geotable/GeoTableWidget.vue